
class WebSocketClient {
  constructor(url, options = {}) {
    // 配置参数
    this.url = url;
    this.reconnectDelay = options.reconnectDelay || 1000; // 重连间隔（毫秒）
    this.maxReconnectDelay = 30000;      // 最大延迟30秒
    this.maxReconnectAttempts = options.maxReconnectAttempts || 10; // 最大重连次数
    this.reConnecting = false;

    // 内部状态
    this.socket = null;
    this.reconnectAttempts = 0;
    this.isManualClose = false; //是否主动关闭
    this.messageQueue = [];
    this.isConnected = false;

    this.onMessage = null;
    this.onOpen = () => {};
    this.onClose = () => {};
    this.onError = () => {};

    // 初始化连接
    this.connect();
  }

  // 连接 WebSocket
  connect() {
    this.socket = new WebSocket(this.url);
    this.socket.onopen = () => {
      console.log("WebSocket 连接成功");
      this.isConnected = true;
      this.reconnectAttempts = 0;
      this.reConnecting = false;
      this.flushMessageQueue(); // 发送积压的消息
      this.onOpen(); // 触发 open 事件
    };

    this.socket.onmessage = (event) => {
      console.log("收到消息:",event.data);
      try {
        //const data = JSON.parse(event.data);
        this.onMessage(event.data);   // 普通消息
      } catch (e) {
        console.error("消息解析失败", e);
        console.error("消息解析失败，数据：", event.data);
      }
    };

    this.socket.onclose = () => {
      console.log("WebSocket 连接关闭");
      this.isConnected = false;
      this.onClose();
      //非主动关闭
      if(!this.isManualClose && !this.reConnecting){
        this.handleReconnect(); // 尝试重连
      }
    };

    this.socket.onerror = (error) => {
      this.isConnected = false;
      this.handleReconnect();
      console.error("WebSocket 错误", error);
    };
  }

  // 发送消息（自动缓存未连接时的消息）
  send(message) {
    const msg = typeof message === "string" ? message : JSON.stringify(message);
    if (this.isConnected && this.socket) {
      this.socket.send(msg);
    } else {
      this.messageQueue.push(msg); // 先缓存，等重连后发送
    }
  }

  // 清空消息队列
  flushMessageQueue() {
    while (this.messageQueue.length > 0 && this.socket) {
      const msg = this.messageQueue.shift();
      this.socket.send(msg);
    }
  }

  // 自动重连
  handleReconnect() {
    this.reConnecting = true;
    if(this.isManualClose){return;}
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      const delay = Math.min(
        this.reconnectDelay * Math.pow(2, this.reconnectAttempts),
        this.maxReconnectDelay
      );
      this.timer = setTimeout(() => {
        this.reconnectAttempts++;
        console.log(`第${this.reconnectAttempts}次重连，${delay / 1000} 秒后尝试第 ${this.reconnectAttempts + 1} 次重连`);
        this.connect();
      }, delay);
    }else{
      console.log('已达到最大重连次数，停止重连');
    }
  }

  // 关闭连接
  close() {
    this.isManualClose = true;
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

// 导出（CommonJS/ES Module）
export default WebSocketClient; // ES6
